import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import RateDetailPanel from '../../components/data_hub/RateDetailPanel';
import { FaArrowLeft } from 'react-icons/fa';

const RateDetailPage = () => {
  const { rateId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
        {/* Header with back button */}
        <div className="bg-white border-b border-gray-200 px-8 py-4 flex-shrink-0">
          <button
            onClick={() => navigate('/data/rates')}
            className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 shadow-sm hover:shadow-md font-ui font-medium"
          >
            <FaArrowLeft />
            <span>Back to List</span>
          </button>
        </div>

        {/* Reusable Rate Detail Panel */}
        <div className="flex-1 overflow-hidden">
          <RateDetailPanel 
            rateId={rateId}
            showUseButton={false}
          />
        </div>
    </div>
  );
};

export default RateDetailPage;
